import Swal from "sweetalert2"

const AlertWarning = ({title, message}) => {


  return Swal.fire({
    icon: 'warning',
    title: title,
    text: message,
    showConfirmButton: false,
  })



}

export default AlertWarning